<template>
    <svg :width="width" :height="height" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
        <defs>
            <clipPath id="clip-Arrow_Left">
                <rect width="24" height="24"/>
            </clipPath>
        </defs>
        <g id="Arrow_Left" clip-path="url(#clip-Arrow_Left)">
            <rect width="24" height="24" fill="rgba(81,91,96,0)"/>
            <g id="Group_13320" data-name="Group 13320">
                <path id="Path_58" data-name="Path 58" d="M0,0H24V24H0Z" :class="svgFillClass" opacity="0"/>
                <path id="Path_59" data-name="Path 59" d="M15.41,7.41,14,6,8,12l6,6,1.41-1.41L10.83,12Z" :class="svgFillClass" />
            </g>
        </g>
    </svg>

</template>

<script>

export default {
    name: "arrowLeftIcon",

    props: {
        width: {
            type: Number,
            default: 32
        },
        height: {
            type: Number,
            default: 32
        },
        svgFillClass: {
            type: String,
            default: 'svg-secondary-color'
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/arrowLeftIcon.vue